import { faFlag } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Dropdown, Spinner } from 'react-bootstrap';

import ChevronDownIcon from '../../assets/images/icons/chevron-down.svg';
import { useFlags } from '../../hooks/useFlags';
import { Event } from '../../interfaces';
import { basic } from '../../theme/colors';

interface Props {
  onChange: (u: { flag: Event['flag'] }) => void;
  flag: Event['flag'];
  disabled?: boolean;
  className?: string;
  'data-accesskey'?: string;
  isLoading?: boolean;
}

export function FlagDropdown(props: Props) {
  const flags = useFlags();

  const { disabled, flag, onChange, className, isLoading } = props;

  const handleChange = (flagId: string | null) => () => {
    onChange({ flag: flagId });
  };

  return (
    <Dropdown className={`hdn-dropdown ${className}`}>
      <Dropdown.Toggle
        variant="light"
        id="dropdown-split-basic"
        data-accesskey="KeyF"
        style={{ flexShrink: 1, flexGrow: 0 }}
        className="hdn-dropdown__toggle"
        disabled={disabled || isLoading}
      >
        {isLoading ? (
          <Spinner animation="border" size="sm" />
        ) : (
          <>
            <FontAwesomeIcon
              icon={faFlag}
              style={{
                color: flags.find((f) => flag === f.id)?.color ?? `${basic.haydenGray2}`,
              }}
            />
            <img className="hdn-dropdown__chevron" src={ChevronDownIcon} alt="⌄" />
          </>
        )}
      </Dropdown.Toggle>

      <Dropdown.Menu data-accesskey={props['data-accesskey']}>
        <Dropdown.Item eventKey="clear" onClick={handleChange(null)}>
          <FontAwesomeIcon icon={faFlag} style={{ color: `${basic.haydenGray2}` }} /> Clear flag
        </Dropdown.Item>

        {flags?.map((f, idx) => (
          <Dropdown.Item eventKey={idx.toString()} onClick={handleChange(f.id)}>
            <FontAwesomeIcon key={f.id} icon={faFlag} style={{ color: f.color }} />
            {f.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
